"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.transformRowUsingColumnMap = exports.prepareTableForImport = void 0;
const cloneDeep_1 = __importDefault(require("lodash/cloneDeep"));
const fromPairs_1 = __importDefault(require("lodash/fromPairs"));
const get_1 = __importDefault(require("lodash/get"));
function prepareTableForImport(table) {
    const res = (0, cloneDeep_1.default)(table);
    res.foreignKeys = [];
    res.indexes = [];
    res.uniques = [];
    res.checks = [];
    if (res.primaryKey)
        res.primaryKey.constraintName = null;
    res.tableEngine = null;
    return res;
}
exports.prepareTableForImport = prepareTableForImport;
function transformRowUsingColumnMap(row, columns) {
    return (0, fromPairs_1.default)(columns.map(col => [col.dst, (0, get_1.default)(row, col.src)]));
}
exports.transformRowUsingColumnMap = transformRowUsingColumnMap;
